import { EstadoComponente, } from "@/shared/components/ui";
import { OrdenesCompra } from "@/shared/interfaces/erp/compras/ordenes-compra.interface";
import { MRT_ColumnDef, MRT_RowData } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import { Ingreso_inventario, MaterialTransferido } from "@/shared/interfaces";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import { cellNotFilter, TABLE_CONSTANTS_COLUMS } from "@/shared";
import Chip from '@mui/material/Chip';
import DoneIcon from '@mui/icons-material/Done';
import ModalObservacionGeneral from "@/shared/components/ui/ModalObservacionesGeneral";
import { getIngresarProductoById } from "@/shared/actions/erp";


export type ProducutosSeleccionados = {
  orde_compra: string;
  numero_factura: string;
  numero_guia_remision: string | null;
  codigo_producto: string;
  cantidad: number
}

const useTableOrdenesCompraFinalizado = () => {
  //********************store
  const handleCopiarLista = useCargarSeriesProductos(s => s.handleCopiarLista)
  //********************state
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [isOpenModal2, setIsOpenModal2] = useState(false)
  const [productosSelected, setProductos] = useState<Ingreso_inventario[]>([])
  const [readProducts, setReadProducts] = useState<Ingreso_inventario[]>([])

  const [codigoProducto, setCodigoProducto] = useState('')
  const [urlPdf, setUrlPdf] = useState<Ingreso_inventario[]>([])
  const [observacionCerrarOrden, setObservacionCerrarOrden] = useState('')

  ////******************function
  const onDetails = (e: MRT_RowData) => {


    setObservacionCerrarOrden(e.observaciones.observacionCerrarOrden)
    const prodcutosSeleccionados: Ingreso_inventario[] = e.ingreso_inventario_data.flatMap((item: any) =>
      item.productos.map((producto: MaterialTransferido) => ({
        id_ingreso_inventario: item.id_ingreso_inventario,
        orden_compra: item.orden_compra,
        numero_factura: item.numero_factura,
        numero_guia_remision: item.numero_guia_remision,
        cantidad: producto.cantidad,
        cantidad_recibida: producto.cantidad_recibida,
        codigo: producto.codigo,
        //id_orden_compra: id
      })))

    //*****************
    /* const descargarPdf: Ingreso_inventario[] = e.ingreso_inventario_data.map((item: Ingreso_inventario, index: any) => ({
      id_ingreso_inventario: item.id_ingreso_inventario,
      url_pdf: item.url_pdf,
      reporte_nombre: `Ingreso N° ${index + 1}`
    })) */

    ////
    const descargarPdf: Ingreso_inventario[] = e.ingreso_inventario_data.some((item: any) => item.url_pdf)
      ? e.ingreso_inventario_data.filter((element: any) => !!element.url_pdf).map((item1: any, index: number) => ({
        id_ingreso_inventario: item1.id_ingreso_inventario,
        url_pdf: item1.url_pdf,
        reporte_nombre: `Ingreso N° ${index + 1}`
      }))
      : [{ url_pdf: '', reporte_nombre: 'El archivo PDF no existe.' }];

    //*****************
    handleCopiarLista(e.detalles)
    setProductos(prodcutosSeleccionados)
    setUrlPdf(descargarPdf)
    setIsOpenModal(true)

  }
  //*************************function
  const informacionFactura = (e: MRT_RowData) => {
    setCodigoProducto(e.codigo)
  }
  //*************************useEffect
  useEffect(() => {
    if (!productosSelected.length && !codigoProducto) return;
    const aux = productosSelected.filter(item => item.codigo === codigoProducto)
    setReadProducts(aux)
  }, [productosSelected, codigoProducto])
  /////////
  const infoOrdenFinalizado = useMemo<MRT_ColumnDef<OrdenesCompra>[]>(
    () => [

      {
        accessorKey: 'detalles',
        header: 'Producto',
        size: 100,
        Cell: ({ row }) => {
          return (
            <Button
              variant="text"
              startIcon={<VisibilityIcon />}
              onClick={async () => {
                const ingrseoSinPdf = row.original?.ingreso_inventario_data
                ?.filter((item:any)=>!item?.url_pdf)
                if(ingrseoSinPdf?.length){
                  for(const ingreso of ingrseoSinPdf){
                    if(!ingreso?.id_ingreso_inventario){
                      console.log("Ingrseo sin ID, no se puede consultar", ingreso)
                      continue
                    }
                    try {
                      const response: any = await getIngresarProductoById(ingreso?.id_ingreso_inventario!)
                      const pdf = response?.data?.url_pdf ?? null
                     
                      if(pdf){
                        ingreso.url_pdf = pdf
                      }
                    } catch (error) {
                      console.log("error al consultar ingreso.")
                    }
                  }
                }
                onDetails(row.original)
              }}
            >
              {'Ver'}
            </Button>
          )
        }
      },
      {
        accessorKey: 'numero_referencia',
        header: 'N° referencia'
      },
      {
        accessorKey: 'solicitud_ingreso',
        header: 'solicitud ingreso'
      },
      {
        accessorKey: 'observaciones.observacionCerrarOrden',
        header: 'Observacion de cierre',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
        Cell: ({ row }) => (
          <ModalObservacionGeneral
            texto={
              row.original.observaciones?.observacionCerrarOrden || 'N/A'
            }
            title="Observación"
          />
        )
      },
      {
        accessorKey: 'plazo_pago',
        header: 'Plazo pago'
      },
      {
        ...cellNotFilter,
        accessorKey: 'fecha_orden',
        header: 'Fecha Orden'
      },
      {
        ...cellNotFilter,
        accessorKey: 'fecha_compra',
        header: 'Fecha Compra'
      },
      {
        ...cellNotFilter,
        accessorKey: 'fecha_entrega',
        header: 'Fecha Entrega'
      },
      {
        accessorKey: 'forma_pago_data.nombre',
        header: 'Forma Pago',
        Cell: ({ row }) => row.original.forma_pago_data?.nombre || 'N/A'
      },
      {
        id: 'proveedor_razon_social',
        accessorKey: 'proveedor_data.razon_social',
        header: 'Proveedor'
      },
      {
        ...cellNotFilter,
        accessorKey: 'estado_orden',
        header: 'Estado',
        Cell: ({ row }) => {

          return (
            <EstadoComponente
              backgroundColor="green"
              texto={row.original.estado_orden!}
            />
          )
        }

      }

    ], []
  )

  const detailsProducts = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(
    () => [
      {
        accessorKey: 'accion',
        header: 'Accion',
        Cell: ({ row }) => {
          return (
            <Tooltip title="información">
              <IconButton
                onClick={() => {
                  informacionFactura(row.original), setIsOpenModal2(true)
                }}
              >
                <VisibilityIcon color="primary" />
              </IconButton>
            </Tooltip>

          )
        }

      },
      {
        accessorKey: 'producto_data.descripcion',
        header: 'Descripcion'
      },
      {
        accessorKey: 'cantidad_aprobada',
        header: 'Cant. Aprobada'
      },
      {
        accessorKey: 'cantidad',
        header: 'Cant. Esperada'
      },
      {
        accessorKey: 'cantidad_recibida',
        header: 'Cant. recibida',
        Cell: ({ row }) => {
          const { cantidad, cantidad_recibida } = row.original
          const despachoTotal = Number(cantidad) === cantidad_recibida
          return (
            <>
              <Chip
                label={
                  <Box display="flex" alignItems="center" gap={0.5}>
                    {cantidad_recibida}
                    {despachoTotal && <DoneIcon fontSize="small" />}
                  </Box>
                }
                variant="filled"
                style={{ backgroundColor: despachoTotal ? '#4caf50' : 'red', padding: '0 10px', borderRadius: '4 px', color: '#fff' }}

              />
            </>
          )
        }
      },

    ], []
  )
  const infoIngresoInventario = useMemo<MRT_ColumnDef<Ingreso_inventario>[]>(
    () => [
      {
        accessorKey: 'codigo',
        header: 'Codigo'
      },
      {
        accessorKey: 'orden_compra',
        header: 'N° Orden Pedido'
      },
      {
        accessorKey: 'numero_factura',
        header: 'N° Factura',
        Cell: ({ row }) => row.original.numero_factura || 'N/A'
      },
      {
        accessorKey: 'numero_guia_remision',
        header: 'N° Remisión',
        Cell: ({ row }) => row.original.numero_guia_remision || 'N/A'
      },

      {
        accessorKey: 'cantidad_recibida',
        header: 'Cant. Recibida'
      }
    ], []
  )

  return {
    infoOrdenFinalizado,
    isOpenModal,
    setIsOpenModal,
    detailsProducts,
    isOpenModal2,
    setIsOpenModal2,
    infoIngresoInventario,
    readProducts,
    urlPdf,
    setProductos,
    setReadProducts,
    observacionCerrarOrden
  }
}
export default useTableOrdenesCompraFinalizado;